import React, { Component } from 'react';
import Cookies from 'universal-cookie';
import Adminheader from './Adminheader';
import Adminsidebar from './Adminsidebar';
import { Setaffiliatefee, getAffMin, getAffMax } from '../../hooks/useContract';
import '../../css/styles.css';
import favicon from "../../images/chainpad/logo.png"
import { getaffhook } from '../../hooks/usebackend';

const cookies = new Cookies();
class AdminPoolSetting extends Component {

    showLoader() {
        document.getElementsByTagName("body")[0].classList.add("overflow_hidden");
        document.getElementById("logo_overlay").style.opacity = 0.5;
        document.getElementById("loader_div").classList.remove("d-none");
        document.getElementById("loader_div").classList.add("d-block");
    }

    hideLoader() {
        document.getElementsByTagName("body")[0].classList.remove("overflow_hidden");
        document.getElementById("logo_overlay").style.opacity = 1;
        document.getElementById("loader_div").classList.remove("d-block");
        document.getElementById("loader_div").classList.add("d-none");
    }


    restrict = async () => {
        var email = cookies.get('cryp-launch-admin-email');
        console.log("email", email);
        if (!email) {
            this.props.history.push("/login")
        }
    }

    getaff = async () => {

        let get = await getaffhook();
        console.log("get", get);
        if (get?.data?.status == true) {
            this.setState({ "getaff": get?.data?.data });
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            afflicatesettingModal: false,
            addsettingModal: false,
            settings: [],
            getaff: [],
            singlesetting: {},
            image: null,
            skip: 0,
            limit: 10,
            pagecount: 0,
            button: 0,
            currentpage: 1,
            affid: {},
            stepcount: 5,
            minAffiliate: 0,
            maxAffiliate: 0,
        };
    }

    onDismiss() {
        this.setState({ afflicatesettingModal: false });
    }

    onDismissAdd() {
        this.setState({ addsettingModal: false });
    }



    componentDidMount() {
        this.restrict()
        this.hideLoader();
        this.fetchData()
    }


    async fetchData() {
        let minFee = await getAffMin()
        let maxFee = await getAffMax()
        minFee = parseFloat(minFee) / 10 ** 18
        maxFee = parseFloat(maxFee) / 10 ** 18
        this.setState({ minAffiliate: minFee })
        this.setState({ maxAffiliate: maxFee })
    }

    render() {
        return (
            <div id="loader_main">
                <div id="loader_div">
                    <span className="spin_round">

                    </span>
                    <img src={favicon} className="logo_load" />
                </div>
                <div className='logo_overlay' id="logo_overlay">


                    <Adminheader />

                    <div className="whole_sec pb-5">
                        <div className='flex_side_right adminisideright'>
                            <Adminsidebar />
                            {/* ongoing_sec */}
                            <div className='right_side_sec adminside'>
                                <div className="right_side_spacing">
                                    <div className='ongoing_sec proj_bg pb-5'>
                                        <div className="container px-1">
                                            <div className='top_heqad_sec mt-5 mt-md-0'>
                                                <div className="row">
                                                    <div className="col-12 col-md-6 flex_cen_col mt-md-5 mb-md-4">
                                                        <p className="banner_subtitle form_subhead">Pool Settings</p>
                                                    </div>
                                                </div>
                                                <div className="inner_bg">
                                                    <div className="container px-1">
                                                        <div className='row det'>
                                                            <div class="col-12 col-md-10 col-lg-9 mx-auto">
                                                                <div class="tab_img">
                                                                    <div className='card_bg card'>
                                                                        <div className='card-body'>
                                                                            <div className='row'>
                                                                                <div class="col-12 mb-3">
                                                                                    <p class="input_desc_sm">Fee</p>
                                                                                    <div class="inputs input-groups noearp_input_admin"><div class="datepicker_input input-group">
                                                                                        <input placeholder="" aria-describedby="basic-addon2" id="price" class="form-control"  />
                                                                                    </div></div>
                                                                                </div>

                                                                                <div class="col-12 mb-3">
                                                                                    <p class="input_desc_sm">Reward</p>
                                                                                    <div class="inputs input-groups noearp_input_admin"><div class="datepicker_input input-group">
                                                                                        <input placeholder="" aria-describedby="basic-addon2" id="price" class="form-control"  />
                                                                                    </div></div>
                                                                                </div>
                                                                                <span class="input-group-text" id="basic-addon2"><button class="get-started-btn">Submit</button></span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* end ongoing_sec */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        )
    }
}

export default AdminPoolSetting